import React, { useState, useEffect } from 'react';
import { ExternalLink, Facebook, Instagram, Twitter, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [isApp, setIsApp] = useState(false);

  // Detect if the user is using the installed PWA/TWA
  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsApp(true);
    }
  }, []);

  return (
    <footer className={`w-full mt-auto ${isApp ? 'bg-[#FFF6E5]' : 'bg-[#2A2A2A]'}`}>
      {/* Main Footer - Hides if installed as App */}
      {!isApp && (
        <div className="border-t-4 border-[#9B111E] pt-12 pb-8 text-white">
          <div className="container mx-auto px-6 max-w-7xl grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">
            
            {/* Brand Column */}
            <div>
              <div className="flex items-center gap-3 justify-center md:justify-start mb-4">
                <img src="/rasraj_logo.jpg" alt="RAS RAJ Logo" className="h-12 w-12 rounded-full object-cover border-2 border-[#D4AF37]" onError={(e) => { e.target.style.display='none'; }} />
                <div className="text-left">
                  <div className="font-bold text-[#D4AF37] text-2xl leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>RAS RAJ</div>
                  <div className="text-[14px] text-white/90" style={{ fontFamily: 'Great Vibes, cursive', marginTop: '-4px' }}>The Mithai Shop</div>
                </div>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto md:mx-0">
                Amethi's most luxurious mithai destination. The taste of tradition, the promise of purity.
              </p>
            </div>
            
            {/* Links Column */}
            <div>
              <h4 className="text-lg font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Quick Links</h4>
              <div className="flex flex-col gap-3 text-sm text-gray-400">
                <Link to="/" className="hover:text-[#D4AF37] transition-colors inline-block">Home</Link>
                <Link to="/products" className="hover:text-[#D4AF37] transition-colors inline-block">Menu</Link>
                <Link to="/about" className="hover:text-[#D4AF37] transition-colors inline-block">About Us</Link>
              </div>
            </div>
            
            {/* Contact Column */}
            <div>
              <h4 className="text-lg font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>Contact & Visit</h4>
              <div className="flex flex-col gap-3 text-sm text-gray-400 items-center md:items-start">
                <div className="flex items-start gap-3">
                  <MapPin size={18} className="text-[#D4AF37] shrink-0 mt-0.5" />
                  <span className="text-left">Near Post Office<br />Amethi, UP 227405</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone size={18} className="text-[#D4AF37] shrink-0" />
                  <span>+91 96288 08394</span>
                </div>
                <div className="flex items-center gap-3 mb-2">
                  <Mail size={18} className="text-[#D4AF37] shrink-0" />
                  <span>info@rasrajthemithaishop.com</span>
                </div>
                <div className="flex gap-5 mt-2">
                  <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors"><Facebook size={20} /></a>
                  <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors"><Instagram size={20} /></a>
                  <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors"><Twitter size={20} /></a>
                </div>
              </div>
            </div>

          </div>
        </div>
      )}

      {/* UT Arts Branding - ALWAYS VISIBLE */}
      <div className={`w-full py-4 pb-24 md:pb-4 ${isApp ? 'border-t border-[#E6D5BC]' : 'border-t border-gray-700/50'}`}>
        <span className={`flex items-center justify-center gap-2 text-sm ${isApp ? 'text-gray-500' : 'text-gray-400'}`}>
          Designed & Developed by
          <a 
            href="https://www.utarts.in" 
            target="_blank" 
            rel="noopener noreferrer"
            className={`font-bold transition-colors flex items-center gap-1.5 ${isApp ? 'text-[#9B111E] hover:text-[#7A0C16]' : 'text-[#D4AF37] hover:text-white'}`}
          >
            <img 
              src="https://tzaxthrqwfgbrcqmtuec.supabase.co/storage/v1/object/public/images/UTArt_Logo.webp" 
              alt="UT Arts Logo" 
              className={`h-5 w-5 rounded-full object-cover border ${isApp ? 'border-[#E6D5BC]' : 'border-[#D4AF37]/50'}`}
            />
            UT Arts
            <ExternalLink size={10} />
          </a>
        </span>
      </div>
    </footer>
  );
}